import { Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';
import React from 'react';

export default function ContactAlert({ contactErrors }) {
  if (contactErrors.length === 0) return null;

  return (
    <Alert bsStyle="danger" className="d-flex align-items-center">
      <FontAwesomeIcon icon={faExclamationCircle} size="2xl"/>
      <div className="ml-4 mt-1">
        <h4>The following errors occurred when trying to save this form. Please fix and re-submit.</h4>
        <ul className="mb-0">
          {contactErrors.map(error => <li key={error}>{error}</li>)}
        </ul>
      </div>
    </Alert>
  );
}

ContactAlert.propTypes = {
  contactErrors: PropTypes.arrayOf(PropTypes.string).isRequired
};
